import React, { useState, useEffect, useRef } from "react";
import request from "../utils/request";
import callInvokeNative from "../utils/callInvokeNative";

import renwu3 from "../assets/images/renwu3.png";
import renwu4 from "../assets/images/renwu4.png";
import renwu5 from "../assets/images/renwu5.png";

import renwu from "../assets/images/renwu.png";
import renwu6 from "../assets/images/renwu6.png";
import renwu7 from "../assets/images/renwu7.png";
import renwu8 from "../assets/images/renwu8.png";
import renwu9 from "../assets/images/renwu9.png";
import renwu10 from "../assets/images/renwu10.png";
import renwu11 from "../assets/images/renwu11.png";
import renwu12 from "../assets/images/renwu12.png";
import renwu13 from "../assets/images/renwu13.png";

const TaskSchedule = ({ clientName, articleId }) => {
  const [taskInfo, setTaskInfo] = useState({
    readed: "0",
    taskStatus: "0",
    taskSchedule: "-",
    taskCompleteCondition: "-",
    taskComplete: false,
  });
  const [readProcess, setReadProcess] = useState(0);

  const [completeMaskShow, setCompleteMaskShow] = useState(false);
  const [getPointsMaskShow, setGetPointsMaskShow] = useState(false);
  const [firstPointsMaskShow, setFirstPointsMaskShow] = useState(false);
  const [taskName, setTaskName] = useState("");
  const [pointsNum, setPointsNum] = useState(0);

  const timer = useRef(null);

  useEffect(() => {
    // 上传积分
    const uploadCmsTaskTraceRes = async () => {
      const param = {
        url: window.location.href,
        duration: 30_000,
      };

      const data = await request.post(
        "/taskIntegralH5/uploadCMSTaskTrace",
        param
      );

      if (data.resultCode === 0) {
        const {
          taskStatus,
          taskSchedule,
          taskCompleteCondition,
          taskName,
          taskIntegral,
        } = data.data.eventResult;
        setTaskInfo((pre) => ({
          ...pre,
          taskStatus,
          taskSchedule,
          taskCompleteCondition,
        }));

        if (taskStatus === "2" && taskCompleteCondition === taskSchedule) {
          setTaskName(taskName);
          setPointsNum(taskIntegral);
          setCompleteMaskShow(true);
        }
      }
    };

    // app 时获取任务状态
    const getCmsTaskTraceRes = async () => {
      const param = {
        url: window.location.href,
      };
      const data = await request.post(
        "/taskIntegralH5/queryCmsTaskTrace",
        param
      );

      if (data.resultCode === 0) {
        const { readed, taskStatus, taskSchedule, taskCompleteCondition } =
          data.data.eventResult;

        setTaskInfo({
          readed,
          taskStatus,
          taskSchedule,
          taskCompleteCondition,
          taskComplete: readed === "1",
        });

        if (taskStatus === "1" && readed !== "1") {
          // 计时器
          const startTime = new Date().getTime();
          timer.current = setInterval(() => {
            const endTime = new Date().getTime();
            if (endTime - startTime >= 30_000) {
              setTaskInfo((pre) => ({
                ...pre,
                taskComplete: true,
              }));
              uploadCmsTaskTraceRes();
              clearInterval(timer.current);
            }
          }, 1000);

          setTimeout(() => {
            setReadProcess(100);
          }, 100);
        }
      }
    };

    // 首次任务奖励
    const getFirstTaskTrace = async () => {
      const param = {
        url: window.location.href,
      };

      const res = await request.post(
        "/taskIntegralH5/uploadFirstCMSTaskTrace",
        param
      );
      if (res.resultCode === 0) {
        const { isFirst } = res.data;

        if (isFirst) {
          setFirstPointsMaskShow(true);
        }
      }
    };

    if (clientName === "app") {
      getCmsTaskTraceRes(); // 任务进度
      getFirstTaskTrace();
      // 发起分享 获取任务状态
      window.appCallTask = async () => {
        const param = {};

        const data = await request.post(
          "/taskIntegralH5/queryArticleShareTaskTrace",
          param
        );

        if (data.resultCode === 0) {
          const { taskStatus, taskName, taskIntegral } = data.data.eventResult;
          if (taskStatus === "2") {
            setPointsNum(taskIntegral);
            setTaskName(taskName);
            setCompleteMaskShow(true);
          }
        }
      };
    }

    return () => {
      clearInterval(timer.current);
      window.appCallTask = null
    };
  }, [clientName, articleId]);

  const onOpenPointsMask = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setGetPointsMaskShow(true);
    setCompleteMaskShow(false);
  };

  const onContinual = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setGetPointsMaskShow(false);

    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端

    const paramNative = {};

    if (isIOS) {
      paramNative.nativeCode = { className: "TaskCenterController" };
    }

    if (isAndroid) {
      paramNative.nativeCode = {
        className: "com.yuge.yixin.mission.MissionCenterActivity",
      };
    }

    callInvokeNative("openNativeFunction", paramNative);
  };

  const closeCurrentMask = (e, handle) => {
    e.stopPropagation();
    e.preventDefault();

    handle(false);
  };

  if (clientName !== "app") {
    return null;
  }

  return (
    <>
      {/* 阅读文章任务提示 app显示 */}
      {clientName === "app" && taskInfo.taskStatus === "1" && (
        <div className="tip-read">
          <div className="progress">
            <div className="bar" style={{ width: `${readProcess}%` }}>
              <div className="barbox"></div>
            </div>
            <div className="tip-txt">
              [阅读资讯文章]任务{taskInfo.taskSchedule}/
              {taskInfo.taskCompleteCondition}
              {taskInfo.taskComplete && "：本篇阅读已完成"}
            </div>
          </div>
        </div>
      )}

      {/* 阅读文章提示 */}
      {completeMaskShow && (
        <div className="pop-bg">
          <div className="ww70 marginauto mtt30">
            <div className="modal-content pr">
              <a
                className="rightclose"
                href="##"
                onClick={(e) => closeCurrentMask(e, setCompleteMaskShow)}
              >
                ✕
              </a>
              <img src={renwu3} width="100%" alt="" />
              <div className="fS14 mt10 tc ml25 mr25">
                您已完成了{taskName}任务， 获得了积分奖励
              </div>

              <div className="tc mt15 mb10">
                <a href="##" onClick={onOpenPointsMask}>
                  <img src={renwu5} width="60%" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {getPointsMaskShow && (
        <div className="pop-bg">
          <div className="ww70 marginauto">
            <div className="modal-content pr">
              <a
                className="rightclose"
                href="##"
                onClick={(e) => closeCurrentMask(e, setGetPointsMaskShow)}
              >
                ✕
              </a>
              <img src={renwu4} width="100%" alt="" />

              <div className="mt15 tc jianban-yellow fS28">{pointsNum}积分</div>
              <div className="fS14  tc">还有更多任务等您来完成</div>
              <div className="tc mb20 mt20">
                <a
                  className="btn-sm animated pulse count5 delay1"
                  href="##"
                  onClick={onContinual}
                >
                  继续做任务
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {firstPointsMaskShow && (
        <div className="pop-bg">
          <div className="ww70 marginauto ">
            <div className="modal-content1 pr animated fadeIn delay1">
              <span className="jifen-start animated fadeIn delay2">
                <div className="start1">
                  <img
                    src={renwu10}
                    width="20"
                    className="animated bounceIn"
                    alt=""
                  />
                </div>
                <div className="start2">
                  <img
                    src={renwu9}
                    width="20"
                    className="animated bounceIn"
                    alt=""
                  />
                </div>
                <img
                  src={renwu8}
                  width="80"
                  className="animated pulse infinite"
                  alt=""
                />
              </span>
              <img src={renwu} width="100%" alt="" />
              <div className="pr">
                <img src={renwu6} width="100%" alt=""/>
                <div className="renwu6-txt renwu6-txt animated fadeIn delay1">
                  <img
                    src={renwu7}
                    width="90%"
                    alt=""
                  />
                  <div className="fS14  tc">
                    <div>这是您本日阅读的首篇资讯文章，</div>
                    <div>
                      奖励您
                      <img
                        src={renwu11}
                        width="25"
                        className=" vm animated tada vb delay2 count2"
                        alt=""
                      />
                      <img
                        src={renwu13}
                        width="25"
                        className="animated tada vb delay2 count2"
                        alt=""
                      />
                      <img
                        src={renwu12}
                        width="25"
                        className="animated tada vb delay2 count2"
                        alt=""
                      />
                      首阅奖励，
                    </div>
                    <div>继续进行阅读资讯文章任务，</div>
                    <div>可赚取更多积分奖励</div>
                  </div>
                  <div className="tc mb20 mt20">
                    <a
                      className="btn-sure animated delay4 fadeInUp"
                      href="##"
                      onClick={(e) => {
                        closeCurrentMask(e, setFirstPointsMaskShow);
                      }}
                    >
                      知道了
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(
  TaskSchedule,
  (preProps, nextProps) => preProps.clientName === nextProps.clientName
);
